import React from "react";
import {
  KBarProvider,
  KBarPortal,
  KBarPositioner,
  KBarAnimator,
  KBarSearch,
  KBarResults,
  useMatches,
  type Action,
} from "kbar";
import { router } from "../router";

const actions: Action[] = [
  {
    id: "home",
    name: "Home",
    keywords: "back",
    perform: () => router.navigate({ to: "/" }),
  },
  {
    id: "quotes",
    name: "Quotes",
    keywords: "quotes",
    perform: () => router.navigate({ to: "/quotes" }),
  },
  {
    id: "anime",
    name: "Anime",
    keywords: "anime",
    perform: () => router.navigate({ to: "/anime" }),
  },
  {
    id: "tasks",
    name: "Tasks",
    keywords: "task",
    perform: () => router.navigate({ to: "/tasks" }),
  },
  {
    id: "daily",
    name: "Daily",
    keywords: "daily",
    perform: () => router.navigate({ to: "/daily" }),
  },
  {
    id: "audio",
    name: "Audio",
    keywords: "audio",
    perform: () => router.navigate({ to: "/audio" }),
  },
  {
    id: "calendar",
    name: "Calendar",
    keywords: "calendar",
    perform: () => router.navigate({ to: "/calendar" }),
  },
];

export const KBarWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <KBarProvider actions={actions}>
      <KBarPortal>
        <KBarPositioner
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <KBarAnimator
            style={{
              maxWidth: "600px",
              width: "100%",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              overflow: "hidden",
            }}
          >
            <KBarSearch
              style={{
                width: "100%",
                padding: "16px",
                fontSize: "16px",
                border: "none",
                borderBottom: "1px solid #eee",
                outline: "none",
                boxSizing: "border-box",
              }}
            />
            <RenderResults />
          </KBarAnimator>
        </KBarPositioner>
      </KBarPortal>
      {children}
    </KBarProvider>
  );
};

function RenderResults() {
  const { results } = useMatches();

  return (
    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
      <KBarResults
        items={results}
        onRender={({ item, active }) =>
          typeof item === "string" ? (
            <div
              style={{
                padding: "8px 16px",
                fontSize: "10px",
                textTransform: "uppercase",
                letterSpacing: "1px",
                color: "#888",
                fontWeight: "bold",
              }}
            >
              {item}
            </div>
          ) : (
            <div
              style={{
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                background: active ? "#0070f3" : "transparent",
                color: active ? "#fff" : "#333",
                transition: "background 0.1s ease",
              }}
            >
              <span style={{ fontSize: "14px" }}>{item.name}</span>
              {item.shortcut?.length ? (
                <div style={{ display: "flex", gap: "4px" }}>
                  {item.shortcut.map((sc) => (
                    <kbd
                      key={sc}
                      style={{
                        padding: "4px 8px",
                        background: active
                          ? "rgba(255,255,255,0.2)"
                          : "#eee",
                        borderRadius: "4px",
                        fontSize: "12px",
                        color: active ? "#fff" : "#666",
                        border: "none",
                      }}
                    >
                      {sc.toUpperCase()}
                    </kbd>
                  ))}
                </div>
              ) : null}
            </div>
          )
        }
      />
    </div>
  );
}
